import moment from "moment-jalaali";

/**
 * تبدیل تاریخ میلادی به شمسی
 * @param {string|Date} date - تاریخ میلادی (ISO string یا Date object)
 * @param {string} format - فرمت خروجی (پیش‌فرض: YYYY/MM/DD)
 * @returns {string} تاریخ شمسی فرمت شده
 */
export const toJalali = (date, format = "jYYYY/jMM/jDD") => {
  // تنظیم زبان و اعداد فارسی
  moment.loadPersian({ usePersian: true });

  try {
    // تبدیل به تاریخ شمسی
    return moment(date).format(format);
  } catch (error) {
    console.error("Error converting date:", error);
    return "تاریخ نامعتبر";
  }
};

// نمونه استفاده:
// toJalali('2024-01-15') => '۱۴۰۲/۱۰/۲۵'
// toJalali(new Date(), 'dddd jD jMMMM jYYYY') => 'دوشنبه ۲۵ دی ۱۴۰۲'
